/* RESPONSIBLE TEAM: team-frontend-tech */
export default function (array, mapByKey) {
  let arrayOfArrays = array.mapBy(mapByKey);

  return arrayOfArrays.reduce(function (initial, current) {
    return initial.concat(current.toArray());
  }, []);
}
